$(document).ready ( function(){

$(".cstm_menu_item .dropdown-inner-menu-item").hover(function () {
  $("a.menu-category-title").removeClass("active-menu");
  $("ul.list-unstyled.side-menu-list").removeClass("active-menu");
  $(this).find("a.menu-category-title").addClass("active-menu");
  $(this).find("ul.list-unstyled.side-menu-list").addClass("active-menu");
});
$(".nav-item.dropdown-menu-list").hover(function () {
  $(".yv-dropdown-detail a.menu-category-title").removeClass("active-menu");
  $(".yv-dropdown-detail ul.list-unstyled.side-menu-list").removeClass(
    "active-menu"
  );
  $(this)
    .find(".yv-dropdown-detail a.menu-category-title.colum-active-1")
    .addClass("active-menu");
  $(this)
    .find(".yv-dropdown-detail ul.list-unstyled.side-menu-list.colum-active-1")
    .addClass("active-menu");
});

// ---
$("li.nav-item.nav-item-mega-menu ").hover(function () {
  $(".custom-mega-menu .heading-menu a.main-link-title").removeClass(
    "active-menu"
  );
  $(".custom-mega-menu .heading-menu .child-link-main").removeClass(
    "active-menu"
  );
  $(this)
    .find(".custom-mega-menu .heading-menu a.main-link-title.colum-active-1")
    .addClass("active-menu");
  $(this)
    .find(".custom-mega-menu .heading-menu .child-link-main.colum-active-1")
    .addClass("active-menu");
});

$(".custom-mega-menu .cstm-below-menu .heading-menu").hover(function () {
  $("a.main-link-title").removeClass("active-menu");
  $(".child-link-main").removeClass("active-menu");
  $(this).find("a.main-link-title").addClass("active-menu");
  $(this).find(".child-link-main").addClass("active-menu");
});


  $('.coll-main-top.wrap-outer').flickity({
             contain: true,
              pageDots: false,
              draggable: true,
              prevNextButtons: true,
              wrapAround:false,
              groupCells: true

          }); 
 
});

document.querySelector(".main-btn-wrap.live-chat.main-btn-link.button.med-btn").onclick = function(e) {
    e.preventDefault();
    document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
  }








